import React, { useRef, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { updateBanner } from '../../services/dashboardContentService';

const DashboardBanner = ({ bannerImageUrl, onUpdate }) => {
  const { user } = useAuth();
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    setError('');
    try {
      await updateBanner(file);
      onUpdate();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update banner');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  return (
    <div style={styles.container}>
      {bannerImageUrl ? (
        <img src={bannerImageUrl} alt="GrubClub banner" style={styles.image} />
      ) : (
        <div style={styles.placeholder}>
          <span style={styles.placeholderText}>🍳 GrubClub</span>
        </div>
      )}

      {user?.is_admin && (
        <>
          <button
            onClick={() => fileInputRef.current.click()}
            style={styles.editBtn}
            disabled={uploading}
          >
            {uploading ? 'Uploading...' : '📷 Edit Banner'}
          </button>
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
        </>
      )}
      {error && <p style={styles.error}>{error}</p>}
    </div>
  );
};

const styles = {
  container: {
    position: 'relative',
    width: '100%',
    marginBottom: '20px',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
  },
  image: {
    width: '100%',
    height: '220px',
    objectFit: 'cover',
    display: 'block',
  },
  placeholder: {
    width: '100%',
    height: '220px',
    background: 'linear-gradient(135deg, #e67e22, #f4a460)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  placeholderText: {
    color: 'white',
    fontSize: '28px',
    fontWeight: '700',
    textShadow: '0 2px 6px rgba(0,0,0,0.2)',
  },
  editBtn: {
    position: 'absolute',
    bottom: '14px',
    right: '14px',
    padding: '8px 16px',
    backgroundColor: 'rgba(255,255,255,0.92)',
    color: '#e67e22',
    border: 'none',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  error: {
    position: 'absolute',
    bottom: '-24px',
    left: 0,
    color: '#e74c3c',
    fontSize: '12px',
  },
};

export default DashboardBanner;
